var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col text-center p-5"},[_c('h1',[_vm._v("404 - Page Not Found")]),_c('p',[_vm._v("Sorry, The page you have requested cannot be found.")])])])])
}]

export { render, staticRenderFns }